import React, { useRef, useState, useEffect, useCallback, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { GridPageStripContent } from '../GridPageStripContent';
import { useTranslations } from '../../../../../shared/src/hooks/use-translations.hook';
import { PromotionsStrip } from '../../Promotions/PromotionsStrip';
import { useScreenWidthLessHook } from '../../../../../shared/src/hooks/use-screen-width-less.hook';
import { PromotionsService } from '../../../../../shared/src/services/promotions.service';
import { usePromotionsHook } from '../../../../../shared/src/hooks/use-promotions.hook';
export const GridPageStripPromotions = () => {
    const [isMobile, setIsMobile] = useState(false);
    const [timeoutReached, setTimeoutReached] = useState(false);
    useScreenWidthLessHook({ setIsWindowWidthLess: setIsMobile });
    const wrapperRef = useRef(null);
    const { t } = useTranslations();
    const stripTitle = t('Promotions');
    const wrapperWidth = wrapperRef?.current?.offsetWidth;
    const { promotionsList } = usePromotionsHook();
    const promotionsAmount = useSelector((state) => state.promotions?.promotionsAmount);

    const handleActionClick = useCallback(() => {
        location.href = '/promotions';
    }, []);

    const mainList = promotionsList?.main;
    const mainWrapped = (mainList !== null && typeof mainList === 'object' && !Array.isArray(mainList))
        ? [mainList]
        : [];

    const combinedLTPromotions = useMemo(() => {
        return PromotionsService.filterPromotionsByStatus([
            ...PromotionsService.getStripPromotions(mainWrapped),
            ...PromotionsService.getStripPromotions(promotionsList?.secondary),
            ...PromotionsService.getStripPromotions(promotionsList?.brand)
        ]);
    }, [promotionsList]);

    const limit = isMobile ? 2 : 3;
    const hasEnoughPromos = combinedLTPromotions.length >= limit;

    //Setting a timeout to show the loader for 30 seconds, and if no Promos are available by then, we hide it.
    useEffect(() => {
        const timeout = setTimeout(() => {
            setTimeoutReached(true);
        }, 30000);

        return () => clearTimeout(timeout);
    }, []);

    const shouldRenderLoader = !hasEnoughPromos && !timeoutReached;
    const promotionsToRender = shouldRenderLoader
        ? Array.from({ length: limit }).map((_, index) => ({
            id: `fake-${index}`,
        }))
        : combinedLTPromotions;

    if (!hasEnoughPromos && timeoutReached && combinedLTPromotions.length < limit) {
        return null;
    }

    return (
        <GridPageStripContent
            headerTitle={stripTitle}
            ref={wrapperRef}
            headerAction={hasEnoughPromos && (
                <button className="grid-page-strip__header-action-item" onClick={handleActionClick}>
                    {t('seeAll')} {!!promotionsAmount && `(${promotionsAmount})`}
                </button>
            )}
        >
            <PromotionsStrip
                parentWidth={wrapperWidth}
                promotions={promotionsToRender}
                isMobile={isMobile}
                isLoading={shouldRenderLoader}
            />
        </GridPageStripContent>
    );
};
